import {useState, useEffect} from 'react';

export const useModalRoot = (id: string): HTMLElement | null => {
    const [modalRoot, setModalRoot] = useState<HTMLElement | null>(null);

    useEffect(() => {
        let root = document.getElementById(id);
        if (!root) {
            root = document.createElement('div');
            root.id = id;
            document.body.appendChild(root);
        }
        setModalRoot(root);

        return () => {
            if (root && root.parentNode === document.body) {
                document.body.removeChild(root);
            }
        };
    }, [id]);

    return modalRoot;
};
